import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const getVerificationCountPerRegion = (startDate, endDate, country, product_code) => {
    let query_params = {
        startDate,
        endDate,
        country,
        product_code,
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_COUNT_PER_REGION, query_params, subscriptionKey);
    return result;
}

const getVerificationCountPerProvince = (startDate, endDate, country, region, product_code) => {
    let query_params = {
        startDate,
        endDate,
        country,
        region,
        product_code,
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_COUNT_PER_PROVINCE, query_params, subscriptionKey);
    return result;
}

const getVerificationLatLngPerRegion = (startDate, endDate, country, region, product_code) => {
    let query_params = {
        startDate,
        endDate,
        country,
        region,
        product_code,
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_LAT_LNG_PER_REGION, query_params, subscriptionKey);
    return result;
}

const getVerificationLatLngPerProvince = (startDate, endDate, country, region, province, product_code) => {
    let query_params = {
        startDate,
        endDate,
        country,
        region,
        province,
        product_code
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_LAT_LNG_PER_PROVINCE, query_params, subscriptionKey);
    return result;
}

const getScanningActivity = (startDate, endDate, country, region, province, product_code, page, limit) => {
    let query_params = {
        startDate,
        endDate,
        country,
        region,
        province,
        product_code,
        page,
        limit,
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_SCANNING_ACTIVITY, query_params, subscriptionKey);
    return result;
}

const GeolocationTrackingService = {
    getVerificationCountPerRegion,
    getVerificationCountPerProvince,
    getVerificationLatLngPerRegion,
    getVerificationLatLngPerProvince,
    getScanningActivity
}

export default GeolocationTrackingService